import { List, Stack, Text, Title } from '@mantine/core';

export const SignInProfiles = () => {
    return (
        <Stack gap="md">
            <Title order={3}>Sign-In Profiles</Title>

            <Text>Sign-in profiles let you customize how the login application behaves. You can create different profiles for different situations.</Text>

            <Title order={4} td="underline">What You Can Customize</Title>

            <List spacing="sm">
                <List.Item><strong>SSO and Password</strong> — Choose whether to show both SSO and password options, or go directly to one method</List.Item>
                <List.Item><strong>Return To</strong> — Show or hide the application list after signing in</List.Item>
                <List.Item><strong>Verbosity Level</strong> — Control how much detail is shown in messages and notifications</List.Item>
            </List>

            <Title order={4} td="underline">Managing Profiles</Title>

            <List type="ordered" spacing="sm">
                <List.Item>Navigate to Sign-In Profiles from the application menu</List.Item>
                <List.Item>Create a new profile or edit an existing one</List.Item>
                <List.Item>Set your preferred options</List.Item>
                <List.Item>The active profile will be used for all future sign-ins on this device</List.Item>
            </List>
        </Stack>
    );
};
